// This icon file is generated automatically.
var PtoCodeLibraryOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M16.13 21.03c0 .14.1.25.23.25h5.78c.13 0 .23-.11.23-.25v-1.5c0-.14-.1-.25-.23-.25h-5.78c-.13 0-.23.11-.23.25v1.5zm-6.1.2l6-5.04a.25.25 0 000-.38l-6-5.03a.25.25 0 00-.4.19v1.96c0 .07.03.14.09.19L13.15 16l-3.43 2.88a.25.25 0 00-.1.2v1.95c0 .21.25.33.41.2zM27.5 3.5h-23a1 1 0 00-1 1v23a1 1 0 001 1h23a1 1 0 001-1v-23a1 1 0 00-1-1zm-1.25 22.75H5.75V5.75h20.5v20.5z", "fill-rule": "nonzero" } }] }, "name": "pto-code-library", "theme": "outlined" };
export default PtoCodeLibraryOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoCodeLibraryOutlined.js
// module id = 3899
// module chunks = 0